export {
  type InviteViaTextMessageFreeModalContentProps,
  InviteViaTextMessageFreeModalContent,
} from './inviteViaTextMessageFreeModalContent';
